var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.344 2.863a.5.5 0 0 0-.687-.726L.34 5.274a1 1 0 0 0 0 1.452l3.316 3.137a.5.5 0 0 0 .687-.726L1.556 6.5H11.5a.5.5 0 1 0 0-1H1.556z",
    clipRule: "evenodd"
  })));
});
const SvgArrowLeftsmall = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowLeftsmall);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjM0NDAxIDIuODYzMjRDNC41NDQ2MiAyLjY3MzQ4IDQuNTUzNDIgMi4zNTcwMiA0LjM2MzY2IDIuMTU2NDFDNC4xNzM5IDEuOTU1OCAzLjg1NzQ0IDEuOTQ3IDMuNjU2ODMgMi4xMzY3NkwwLjM0MDY1MSA1LjI3MzUxQy0wLjA3NjQ0MSA1LjY2ODA0IC0wLjA3NjQ0MSA2LjMzMTk2IDAuMzQwNjUxIDYuNzI2NDlMMy42NTY4MyA5Ljg2MzI0QzMuODU3NDQgMTAuMDUzIDQuMTczOSAxMC4wNDQyIDQuMzYzNjYgOS44NDM1OUM0LjU1MzQyIDkuNjQyOTggNC41NDQ2MiA5LjMyNjUyIDQuMzQ0MDEgOS4xMzY3NkwxLjU1NjQzIDYuNUgxMS41MDAyQzExLjc3NjQgNi41IDEyLjAwMDIgNi4yNzYxNCAxMi4wMDAyIDZDMTIuMDAwMiA1LjcyMzg2IDExLjc3NjQgNS41IDExLjUwMDIgNS41SDEuNTU2NDNMNC4zNDQwMSAyLjg2MzI0WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";